
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      //import css for availability and price pages
import '../css/new-reservation-staydetails.css';
import $$ from 'Dom7';
import actions from '../js/actions.js';
import URLS from '../js/Urls.js';
var ContReservation;
var ReservationInfo;
var Customer = {};
export default {
  data: function () {
    return {
      loginobject: actions.LoginGetResult(),
      RoomDetails: {},
      ReservationInfo: {},
      Countries: {},
      emailCheck: false,
      Customer: {
        FirstName: null,
        LastName: null,
        Email: null,
        Phone: null,
        CustomerID: 0
      }
    };
  },

  beforeDestroy() {
    var self = this;
  },

  methods: {
    searchUser() {
      console.log("search");
      var self = this;
      this.$f7router.navigate('/search-user/');
    },

    checkText: function () {// const textQuary = $("#email-input").val();
      // if (textQuary?.length > 0) {
      //     $$('#ContBtn2').prop('disabled', false);
      // }
      // else {
      //     $$('#ContBtn2').prop('disabled', true);
      // }
    }
  },
  on: {
    pageInit: function (e, page) {
      var self = this;
      self.$f7.smartSelect.create({
        el: '.showsmartselect',
        openIn: 'popup',
        popupCloseLinkText: 'Save' // ✅ This sets the close button text to "Save"

      });
      var customer = JSON.parse(localStorage.getItem('searchCustomer'));

      if (customer) {
        $$('#countryDropdown').val(customer?.Country);
        this.$setState({
          Customer: customer
        });
      }

      ContReservation = localStorage.getItem('ContReservation');
      ContReservation = JSON.parse(ContReservation);
      var allcountries = localStorage.getItem('Countries');
      allcountries = JSON.parse(allcountries);
      this.$setState({
        RoomDetails: ContReservation,
        Countries: allcountries
      });
      var loginobject = actions.LoginGetResult();
      $('#ContBtn2').on('click', async function () {
        const disableButton = status => $('#ContBtn2').prop('disabled', status);

        const showToast = (message, color = 'red') => {
          app.f7.toast.create({
            text: message,
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: color,
            closeTimeout: 3000
          }).open();
        };

        const isEmailValid = email => email && validateEmail(email);

        const getInputValue = selector => $(selector).val();

        const isCheckboxChecked = selector => $(selector).prop('checked');

        disableButton(true);
        const fstname = getInputValue('.firstname');
        const lstname = getInputValue('.lastname');
        const mail = getInputValue('.email');
        const mobile = getInputValue('.mobile');
        const country = getInputValue('#countryDropdown');
        const notSwitchMail = isCheckboxChecked('.toggle-init-Email input');
        const notSwitchSms = isCheckboxChecked('.toggle-init-Sms input');
        const note = getInputValue('#reservation-note');

        if (mail && !isEmailValid(mail)) {
          showToast('Email is not correct');
          disableButton(false);
          return;
        }

        if (country === '-') {
          showToast('You should select a valid country');
          disableButton(false);
          return;
        }

        if (!fstname || !lstname || !country) {
          showToast('You should fill in all the fields of the form');
          disableButton(false);
          return;
        }

        const confirmDialog = message => {
          return new Promise((resolve, reject) => {
            app.f7.dialog.confirm(message, "", () => resolve(true), () => resolve(false));
          });
        };

        if (!mail && !self.emailCheck) {
          const proceed = await confirmDialog("You're about to proceed without an email. Continue?");

          if (!proceed) {
            disableButton(false);
            return;
          }

          self.emailCheck = true;
        }

        const ContReservation = JSON.parse(localStorage.getItem('ContReservation')) || {};
        let roomid = null;

        if (localStorage.getItem('newRevRoomID') !== "") {
          try {
            roomid = parseInt(localStorage.getItem('newRevRoomID'));
          } catch (e) {
            roomid = null;
          }
        }

        const obj = {
          PropertyID: loginobject.PropertyID,
          UserID: loginobject.UserID,
          UserRoleID: loginobject.UserRoleID,
          fstname,
          lstname,
          mail,
          mobile,
          country,
          notSwitchMail,
          notSwitchSms,
          RoomID: roomid,
          createOffer: ContReservation?.isOffer || false,
          note,
          customerID: customer?.CustomerID || 0
        };

        try {
          app.f7.preloader.show();
          const response = await app.f7.request.promise.postJSON(URLS.CompleteReservation, {
            obj,
            ContReservation
          });
          app.f7.preloader.hide();

          if (response.data === 'Error') {
            showToast('Reservation did not complete');
            disableButton(false);
            return;
          }

          localStorage.setItem('CompleteReservation', JSON.stringify(response.data));
          localStorage.setItem('newRevRoomID', '');
          self.$setState({
            ReservationInfo: response
          });
          app.f7.views.main.router.navigate('/new-reservation-complete/', {
            transition: 'f7-parallax'
          });
        } catch (error) {
          console.error(error);
          showToast('An error occurred while processing your reservation.');
        } finally {
          disableButton(false);
        }
      });

      function validateEmail(email) {
        // Regular expression for validating email format
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
      }

      $$('#editbtn').on('click', function () {
        app.f7.views.main.router.navigate('/new-reservation-home/');
      });
      $$('#editbtn1').on('click', function () {
        app.f7.views.main.router.navigate('/new-reservation-home/');
      });
      $$('#editbtn2').on('click', function () {
        app.f7.views.main.router.navigate('/new-reservation-home/');
      });
      $$('#editbtn3').on('click', function () {
        app.f7.views.main.router.navigate('/new-reservation-home/');
      });
      $$('#editbtn4').on('click', function () {
        app.f7.views.main.router.navigate('/new-reservation-home/');
      });
    },

    pageBeforeRemove() {}

  },
  id: 'c3ccb891b4',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=new-reservation-staydetails><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class="link back"><i class="icon icon-back"></i></a></div><div class=title>';
      r += Template7Helpers.t.call(ctx_1, 'staydetails', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><div class="toolbar toolbar-bottom"><div class=toolbar-inner><div class=row style="height: 100%"><div class="col-40 total-value"><span class="badge custom-badge-black"><b>';
      r += c(ctx_1.RoomDetails.totalSelectedRooms, ctx_1);
      r += '</b></span> <span style="margin-bottom: auto; margin-top: auto">';
      r += c(ctx_1.RoomDetails.totalPriceStepper, ctx_1);
      r += ' </span><span style="margin-bottom: auto; margin-top: auto; margin-left: 5px">€</span></div><button id=ContBtn2 class="col-60 contbtn" style="border: none"><span style="margin-top: 13px; font-size: 15px">';
      r += Template7Helpers.t.call(ctx_1, 'continue', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span></button></div></div></div><div class="page-content newreservationpage"><div class=card><div class=card-header style="color: #7373bb; font-weight: bold">Price Details</div><div class=row>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.RoomDetails.infoList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="card-content card-content-padding col-85" style="display: flex; flex-direction: column"><div><b>';
          r += c(ctx_2.AllocatedRooms, ctx_2);
          r += '</b> x Rooms ';
          r += c(ctx_2.RoomTypeName, ctx_2);
          r += ' x Nights ';
          r += c(ctx_2.Nights, ctx_2);
          r += '</div><div style="margin-top: 5px">';
          r += c(ctx_2.DateFrom, ctx_2);
          r += ' - ';
          r += c(ctx_2.DateTo, ctx_2);
          r += '</div></div><div class=col-15 style="margin-top: 17px">';
          r += c(ctx_2.TotalPrice, ctx_2);
          r += '€</div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=card-footer style="font-weight: bold; color: black">Total<div class=footprce style="font-weight: bold; color: black"><b>';
      r += c(ctx_1.RoomDetails.totalPriceStepper, ctx_1);
      r += '€</b></div></div></div><div class=card><div class=row>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.RoomDetails.infoList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="card-content card-content-padding col-85">';
          r += c(ctx_2.RoomTypeName, ctx_2);
          r += ' : ';
          r += c(ctx_2.stepperguests, ctx_2);
          r += ' Adults, ';
          r += c(ctx_2.stepperchild, ctx_2);
          r += ' Childrens<div class=textinfo style="color: #72a772"></div>✓';
          r += c(ctx_2.RateName, ctx_2);
          r += '</div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<div class="list customlist"><ul><li class="item-content item-input item-input-with-info"><div style="width: 100%;display: flex;align-items: center;"><div class=item-inner style="width: 80%;"><div class="item-title item-label">';
      r += Template7Helpers.t.call(ctx_1, 'FirstName', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=item-input-wrap><input type=text class=firstname placeholder="Your name" required validate value=';
      r += c(ctx_1.Customer?.FirstName, ctx_1);
      r += '> <span class=input-clear-button></span></div></div><div @click=searchUser() class=search-user-wrapper><span class=material-icons>visibility</span></div></div></li><li class="item-content item-input item-input-with-info"><div class=item-inner><div class="item-title item-label">';
      r += Template7Helpers.t.call(ctx_1, 'LastName', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=item-input-wrap><input type=text class=lastname placeholder="Your last name" required validate value=';
      r += c(ctx_1.Customer?.LastName, ctx_1);
      r += '> <span class=input-clear-button></span></div></div></li><li class="item-content item-input item-input-with-info"><div class=item-inner><div class="item-title item-label">';
      r += Template7Helpers.t.call(ctx_1, 'EmailAddress', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=item-input-wrap><input id=email-input type=email @input=checkText class=email placeholder="Your e-mail" value="';
      r += Template7Helpers.if.call(ctx_1, ctx_1.Customer?.Email, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += c(ctx_2.Customer?.Email, ctx_2);
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"> <span class=input-clear-button></span></div></div></li><li class="item-content item-input item-input-with-info"><div class=item-inner><div class="item-title item-label">';
      r += Template7Helpers.t.call(ctx_1, 'MobileNumber', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=item-input-wrap><input type=text class=mobile placeholder="Enter number" value=';
      r += c(ctx_1.Customer?.Phone, ctx_1);
      r += '> <span class=input-clear-button></span></div></div></li><li class="item-content item-input item-input-with-info"><div class=item-inner><div class="item-title item-label">';
      r += Template7Helpers.t.call(ctx_1, 'country', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' / ';
      r += Template7Helpers.t.call(ctx_1, 'region', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init showsmartselect" data-open-in=popup data-page-back-link-text=Done data-searchbar=true data-popup-close-link-text=Save data-searchbar-placeholder="Search Country"><select name=mac-windows id=countryDropdown>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Countries, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style="color: black">';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content style="margin-left: -23px"><div class=item-inner><div class=item-title></div></div></div></a></div></div></li></ul></div></div></div><div class=card><div class=row><div class=item-inner style="width: 100%"><div class="item-title item-label note-label">Note</div><div class=item-input-wrap><textarea id=reservation-note style="width: 100%; min-height: 70px; padding: 5px"></textarea></div></div></div></div><div class=block><div class=row><div class=col-80>';
      r += Template7Helpers.t.call(ctx_1, 'SendConfirmEmail', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=col-20><label class="toggle toggle-init toggle-init-Email color-green"><input type=checkbox> <span class=toggle-icon></span></label></div></div><!-- <div class="row" style="margin-top: 20px">\r\n                    <div class="col-80">Create Proposal</div>\r\n                    <div class="col-20">\r\n                        <label class="toggle toggle-init toggle-init-Offer color-green">\r\n                            <input type="checkbox" />\r\n                            <span class="toggle-icon"></span>\r\n                        </label>\r\n                    </div>\r\n                </div> --></div></div></div>';
      return r;
    }(this);
  },

  style: `
    .search-user-wrapper {
        margin-left: 10px;
        border: 1px solid black;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 6px 10px;
        border-radius: 8px;
    }

    .note-label {
        margin-left: 15px;
        font-size: 16px;
        font-weight: 600;
        color: #430080;
        margin-top: 2px;
    }

    .item-after {
        color: black;
    }

    .list .item-after {
        margin-left: 0px;
        color: black;
    }
`,
  styleScoped: false
};
    